<template>
  <div>
      <base-card>
        <div class="success-container d-flex align-center">
          <img src="@/assets/img/module_store/success.png" class="col-xs-8 pt_25 my_30" />
          <div class="success-text mt_10 col-xs-9">
            <p>Troca de forma de pagamento realizada com sucesso!</p>
            <p>
              <br />
            </p>
            <p>Sua próxima cobrança será realizada neste cartão.</p>
          </div>
        </div>
        <div class="mt_10 py_30 d-flex justify-center">
            <div class="col-xs-8 d-flex align-stretch success-link-container">
                <base-button text="IR PARA MINHA CONTA" @click="$emit(`close`)"/>
            </div>
        </div>
      </base-card>
  </div>
</template>
<script>
import BaseButton from "@/components/Button";
import BaseCard from "@/components/Card";

export default {
  components: { BaseButton, BaseCard }
};
</script>
<style scoped>

.success-container {
  flex-direction: column;
}

.success-link-container .btn {
    flex: 1
}

.success-text p {
  text-align: center;
  font: normal normal 300 16px/19px Lato;
  letter-spacing: 0px;
  color: #999999;
  opacity: 1;
}
</style>